import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { MAIN_SITE_URL, categories } from "@/mocks/categories";
import { articlesByLang } from "@/lib/articles";

export default function Footer({ lang }: { lang: string }) {
  const { t } = useTranslation();
  const articles = articlesByLang[lang] ?? [];

  return (
    <footer className="bg-secondary-50 border-t border-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="mx-auto max-w-7xl grid grid-cols-1 gap-10 md:grid-cols-3">
          <div>
            <div className="flex items-center gap-2 text-foreground-900 font-heading font-bold text-lg mb-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-extrabold">
                U
              </span>
              <span>usfans spreadsheet</span>
            </div>
            <p className="text-sm text-foreground-600 leading-relaxed">{t("footer.tagline")}</p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">
              <a href="#categories" className="hover:text-primary-600 transition-colors">
                {t("nav.categories")}
              </a>
            </h4>
            <ul className="grid grid-cols-2 gap-2 text-sm">
              {categories.slice(0, 8).map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {t(cat.nameKey)}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-foreground-900 mb-4">
              {t("nav.articles")}
            </h4>
            <ul className="space-y-2 text-sm">
              {articles.map((article) => (
                <li key={article.slug}>
                  <Link
                    to={`/${lang}/${article.slug}`}
                    className="text-foreground-600 hover:text-primary-600 transition-colors"
                  >
                    {article.h1}
                  </Link>
                </li>
              ))}
              <li>
                <a
                  href={MAIN_SITE_URL}
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-primary-600 hover:text-primary-700 font-medium transition-colors"
                >
                  {t("footer.mainSite")} →
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mx-auto max-w-7xl mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-foreground-500 leading-relaxed max-w-2xl">{t("footer.disclaimer")}</p>
          <p className="text-xs text-foreground-500 whitespace-nowrap">
            © {new Date().getFullYear()} usfanssheet.today. {t("footer.allRights")}
          </p>
        </div>
      </div>
    </footer>
  );
}